import { useEffect } from 'react'

// helpers
import { hasEnoughToShow } from 'src/actions/app-state/utils'
import { useScrollListener } from 'src/hooks_shared/use_event_listener'

const useScrollInvoker = (callback: () => void, initialLoad: boolean = true) => {
  // If the page already is in a state where there is not enough content
  // This is relevant for people with large screens
  useEffect(() => {
    if (initialLoad && !hasEnoughToShow()) {
      callback()
    }
  })

  useScrollListener(callback, { passive: true })
}

export default useScrollInvoker
